@if (!!selected) {
  <div data-testid="beerstyle-selected-value">{{ selected.name }}</div>
} @else {
  Select
}

<ion-modal [isOpen]="isOpenSignal()" (willDismiss)="onWillDismiss($event)" data-testid="beerstyle-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Beer Styles</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="cancel()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-searchbar
        [value]="searchPhrase"
        animated="true"
        [debounce]="100"
        (ionInput)="onSearchChange($event)"
      ></ion-searchbar>
    </ion-header>
    @if (!!beerstyles && !isAddItem) {
      <ion-content class="ion-padding">
        <ion-card class="ion-no-margin ion-no-padding">
          <ion-card-content class="ion-no-padding">
            <ion-list class="ion-no-padding" lines="full" data-testid="beerstyle-modal-list">
              @for (item of beerstyles; track item.id) {
                <ion-item button data-testid="beerstyle-modal-item" [attr.data-beerstyle-name]="item.name">
                  <ion-label (click)="select(item)">
                    {{ item.name }}
                    @if (item.id === selected?.id) {
                      <ion-icon name="checkmark-circle" color="success"></ion-icon>
                    }
                    @if (!!item.barId) {
                      <ion-note><br />Custom</ion-note>
                    }
                  </ion-label>
                  @if (!!item.barId) {
                    <ion-button (click)="confirmDeleteBeerstyle(item)" slot="end" fill="clear" shape="round" color="danger" size="default">
                      <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
                    </ion-button>
                  }
                </ion-item>
              }
            </ion-list>
            @if (beerstyles.length === 0) {
              <div class="ion-padding ion-text-center">
                <strong>No result</strong>
              </div>
            }
          </ion-card-content>
        </ion-card>
      </ion-content>
    }
    @if (!isAddItem) {
      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="isAddItem = true">
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    }
    @if (isAddItem) {
      <ion-content>
        <ion-input type="text" [(ngModel)]="newItemName" placeholder="Beerstyle Name"></ion-input>
        <ion-button (click)="addItem.emit(newItemName)" expand="block" fill="clear" shape="round">
          Add
        </ion-button>
      </ion-content>
    }
  </ng-template>
</ion-modal>
<ion-modal [isOpen]="isAddItem" (willDismiss)="onWillDismissAddNew($event)">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>New Beer Style</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="cancelAddNew()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-card class="ion-no-margin ion-no-padding">
        <ion-card-content class="ion-no-padding">
          <ion-item lines="none">
            <ion-input
              label="Name"
              labelPlacement="floating"
              required="required"
              type="text"
              [(ngModel)]="newItemName"
              placeholder="Beer Style Name"></ion-input>
          </ion-item>
        </ion-card-content>
      </ion-card>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button [disabled]="!newItemName" color="success" fill="solid" (click)="addInternalItem(newItemName)">
            Add Beer Style
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
